enum DeviceTypeEnum {
	None = 'None',
	BikeLock = 'BikeLock',
	DoorLock = 'DoorLock',
	TrailerLock = 'TrailerLock',
	Router = 'Router',
	BorderRouter = 'BorderRouter',
	VehicleTracker = 'VehicleTracker',
}

export default DeviceTypeEnum;
